import React from 'react';
import { Outlet } from 'react-router-dom';
import {
    ResponsiveAppBar,
    ResponsiveDrawer
} from 'components';
import { CoreRoutes } from 'app-constants';
import { Box } from '@mui/material';

const drawerWidth = 240;

const processRouteToTitle = (route: string): string => {
    return `Business Excellence ${route !== CoreRoutes.home
        ? ' - ' +
        route
            .replace('/', '')
            .replace('-', ' ')
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ')
        : ''
        }`;
};
export const AccountInformationLayout = () => {
    return (
        <>
            <ResponsiveAppBar drawerWidth={drawerWidth} title={processRouteToTitle(window.location.pathname)} />
            <ResponsiveDrawer drawerWidth={drawerWidth} userIsAdministrator={true} />
            <Box height={'calc(100vh - 64px)'}>
                <Outlet />
            </Box>
        </>
    );
};
